import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../cdl/Toast/useToasts';
import { updateAgent } from '../common/api/clients/agent.api';
import { queries } from '../common/api/queryKeys/queries';
import { translate } from '../common/helpers/translate.helper';

export const useAgentEdit = (onSuccess) => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();

    return useMutation({
        mutationFn: updateAgent,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.agents._def });
            onSuccess?.();

            addToast(translate('updateAgentForm.toast.success'));
        },
        onError: () => {
            addErrorToast(translate('updateAgentForm.toast.error'));
        },
    });
};
